export type CatchedError = unknown;

export class ExtendedError extends Error {
    public readonly innerError: CatchedError;

    public constructor(message: string, innerError?: ExtendedError | Error | CatchedError) {
        const errorMessage = ExtendedError.getErrorMessage(innerError);
        super(message + (errorMessage != undefined ? "\n" + errorMessage : ""));
        // NOTE Эта конструкция работает при запуске тестов в node.js. Для других сред тоже бы проверить и найти решение
        // NOTE если надо. Очень удобно, что при прокидывании ошибки можно найти исходное место выброс исключения
        if (innerError != undefined && innerError instanceof Error) {
            this.stack = (this.stack ?? "") + "\n" + (innerError.stack ?? "");
        }
        this.innerError = innerError;
    }

    private static getErrorMessage(innerError?: CatchedError): undefined | string {
        if (innerError == undefined) {
            return undefined;
        }
        if (innerError instanceof Error) {
            return innerError.message;
        }
        // eslint-disable-next-line @typescript-eslint/no-base-to-string
        return `${innerError}`;
    }
}
